import styled from "styled-components";

const StyledHeaderContent = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  img {
    height: 40px;
  }

  .airline-logo-mobile {
    display: none;
  }

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    .airline-logo {
      display: none;
    }
    .airline-logo-mobile {
      display: block;
    }
  }
`;

export default StyledHeaderContent;
